<div class="customers">
    <div class="card" style="padding: 1rem;">
        <div class="card-body" style="padding: 20px;">
            <div class="row">
                <div class="d-flex justify-content-between">
                    <div>
                        <p style="text-align: left;
                            font: normal normal bold 26px/53px Montserrat;
                            letter-spacing: 0px;
                            color: #00B09E;
                            opacity: 1;">Plan de Gestión de Convivencia</p>
                    </div>
                    <div class="" style="text-align: left;">
                        <div class="d-flex justify-content-end" style="background: #F6F6F6 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1;
                        padding: 15px;
                        ">
                            <p class="info-label">JARDÍN INFANTIL: </p>

                            <p class="info-data">{{dataJardin.jardin}}</p>

                            <p class="info-label">CÓDIGO: </p>

                            <p class="info-data">{{dataJardin.rbd}}</p>

                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-12">
                    <p style="font: normal normal 600 14px/18px Montserrat;
                    letter-spacing: 0px;
                    color: #30374B;
                    text-transform: uppercase;
                    display: inline-block;
                    opacity: 1;">
                        Presentación:
                    </p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;"><b></b></p>
                    <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">El Plan de Gestión de Convivencia corresponde a un conjunto de estrategias, compuestas por actividades planificadas por la comunidad educativa, dirigidas a favorecer la buena convivencia en la Unidad Educativa. Su propósito es “Orientar a la comunidad educativa en el desarrollo de estrategias para promover el buen trato, el respeto y prevenir cualquier forma de manifestación de maltrato entre sus integrantes”. 
                        El presente plan ha sido elaborado con participación de la comunidad educativa, liderado técnicamente por la Encargada de Convivencia y aprobado por la Directora/Encargada de la Unidad Educativa. </p>
                </div>
            </div>
            <br>
            <div class="row  justify-content-end mb-2">
                <button type="button" (click)="verDocumento()"  class="btn btn-light btn-send"  >DESCARGAR</button>
                <button type="button" (click)="guardar()"  class="btn btn-light btn-send" *ngIf="!simulacion" [disabled]="planGestionConvivenciaModel.fechaElavoracion != null "  >GUARDAR</button>
                <button type="button" (click)="enviar()"  class="btn btn-light btn-send" *ngIf="!simulacion" [disabled]="planGestionConvivenciaModel.fechaElavoracion != null " >FINALIZAR</button>
            </div>
            <div class="row">
                <div class="col-sm-12">
                   <!-- ***************Inicio Datos Unidad Educativa***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-1" *ngIf="isCollapsed1" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">1</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-1"  *ngIf="!isCollapsed1" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">1</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Datos Unidad Educativa</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-1" style="margin: 10px;" *ngIf="isCollapsed1" alt="avatar" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-1" style="margin: 10px;" *ngIf="!isCollapsed1" alt="avatar" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse1="ngbCollapse" [(ngbCollapse)]="isCollapsed1">
                                            <div class="row">
                                               <!-- ******************************** -->
                                               <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-1"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"><strong> </strong></div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                        
                                                                        <div class="">
                                                        
                                                                            <table class="table-info">
                                                                                <tr>
                                                                                    <td>
                                                                                        <p class="table-row-title">UNIDAD EDUCATIVA:</p>
                                                                                    </td>
                                                                                    <td>
                                                                                        {{planGestionConvivenciaModel.unidadEducativa}}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr class="table-tr-shadow">
                                                                                    <td>
                                                                                        <p class="table-row-title">COMUNA:</p>
                                                                                    </td>
                                                                                    <td> {{planGestionConvivenciaModel.comuna}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        <p class="table-row-title">REGIÓN:</p>
                                                                                    </td>
                                                                                    <td> {{planGestionConvivenciaModel.region}}</td>
                                                                                </tr>
                                                                                <tr class="table-tr-shadow">
                                                                                    <td>
                                                                                        <p class="table-row-title">APROBADO:</p>
                                                                                    </td>
                                                                                    <td> {{planGestionConvivenciaModel.aprobado}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        <p class="table-row-title">FECHA ELABORACIÓN:</p>
                                                                                    </td>
                                                                                    <td>{{planGestionConvivenciaModel.fechaElavoracion | date:'dd/MM/yyyy'}}</td>
                                                                                </tr>
                                                                                <tr class="table-tr-shadow">
                                                                                    <td>
                                                                                        <p class="table-row-title">FECHA MODIFICACIÓN:</p>
                                                                                    </td>
                                                                                    <td>{{planGestionConvivenciaModel.fechaActualizacion | date:'dd/MM/yyyy'}}</td>
                                                                                </tr>
                                                                                
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                               <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- ***************Fin Datos Unidad Educativa***************** -->


                    <!-- ***************Inicio Diagnostico***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-2" *ngIf="isCollapsed2" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">2</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-2"  *ngIf="!isCollapsed2" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">2</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Diagnóstico</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-2" style="margin: 10px;" *ngIf="isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-2" style="margin: 10px;" *ngIf="!isCollapsed2" alt="avatar" (click)="collapse2.toggle()" [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse2="ngbCollapse" [(ngbCollapse)]="isCollapsed2">
                                            <div class="row">
                                                 <!-- ******************************** -->
                                                <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-2"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"><strong> SISTEMATIZACIÓN DEL DIAGNÓSTICO PARA LA CONSTRUCCIÓN DEL PLAN DE GESTIÓN DE CONVIVENCIA </strong></div>
                                                                </div>
                                                            </div>
                                                            <div class="row" style="padding: 20px;">
                                                                <mat-form-field class="w-100" hintLabel="Max. 5000 caracteres">
                                                                    <textarea
                                                                    rows="8" 
                                                                    cols="20" 
                                                                    style="height: 300px;width: 100%;background: #F5F6FC 0% 0% no-repeat padding-box; border-radius: 10px;border: none;"
                                                                    maxlength="5000"
                                                                    autocomplete="off"
                                                                    matInput
                                                                     [disabled]="simulacion"
                                                                    id="diagnostico"
                                                                    name="diagnostico"
                                                                    [(ngModel)]="this.planGestionConvivenciaModel.diagnostico"
                                                                    ></textarea>
                                                                    <mat-hint align="end">{{this.planGestionConvivenciaModel.diagnostico.length || 0}}/5000</mat-hint>
                                                                </mat-form-field>  
                                                                <mat-error *ngIf="this.planGestionConvivenciaModel.diagnostico.length>4999">Max. caracteres alcanzado</mat-error>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************Fin Diagnostico***************** -->
                    
                    <!-- ***************Inicio Diagnostico***************** -->

                    <div class="customers">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="divDimension">
                                    <div class="row">
                                        <div class="col-sm-1 color-back-area-3" *ngIf="isCollapsed3" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        border-bottom-left-radius: 10px;color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">3</p>
                                        </div>
                                        <div class="col-sm-1 color-back-area-3"  *ngIf="!isCollapsed3" style="font-size: 24px; margin: 0px; border-top-left-radius: 10px;
                                        color: antiquewhite;">
                                            <p style="padding: 20px;margin-left: 25px;font-weight: bold;">3</p>
                                        </div>
                                        <div class="col-sm-10">
                                            <p class="dataFecha" style="margin: 20px;">Plan de Gestión de Convivencia</p>
                                        </div>
                                        <div class="col-sm-1 ">
                                            <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample"><i class="fas fa-plus"></i></button>
                                            <button class="btn-collapser color-area-3" style="margin: 10px;" *ngIf="!isCollapsed3" alt="avatar" (click)="collapse3.toggle()" [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseExample"><i class="fas fa-minus"></i></button>
                                        </div>
                                        <div class="row " #collapse3="ngbCollapse" [(ngbCollapse)]="isCollapsed3">
                                            <div class="row">
                                                 <!-- ******************************** -->
                                                 <div class="customers">
                                                    <div>
                                                        <div class="card-body">
                                                            <div class="row">
                                                                <div class="separator color-back-area-3"  style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                                                                    <div class="estrategia-text"><strong> CALENDARIO DE ACTIVIDADES A REALIZAR DURANTE EL AÑO LECTIVO </strong></div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div *ngFor="let estrategia of planGestionConvivenciaModel?.estrategias; let indice=index">
                                                                    <app-estrategia-pgc [estrategia]="estrategia" [index]="indice" [readonly]="simulacion" ></app-estrategia-pgc>
                                                                </div>
                                                            </div>
                                                            <div class="row  justify-content-end mb-2">
                                                                <button type="button" (click)="agregarEstrategia()"  class="btn btn-light btn-send" style="width: 250px;" [disabled]="planGestionConvivenciaModel.estrategias.length > 3 " *ngIf="!simulacion" >AGREGAR ESTRATEGIA</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            <!-- ******************************** -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ***************Fin Diagnostico***************** -->

                    <div class="row">
                        <table class="table-info">
                            <tr>
                                <td style="width: 350px;">
                                    <p class="table-row-title">Responsable del seguimiento del Plan:</p>
                                </td>
                                <td style="width: 600px;">
                                    <input type="text" value="{{planGestionConvivenciaModel.responsable}}" [(ngModel)]="planGestionConvivenciaModel.responsable" [disabled]="simulacion">
                                    <button
                                        [ngbPopover]="popContentObjetivo"
                                        popoverTitle="Información"
                                        triggers="mouseenter:mouseleave"
                                        style="border: none; background-color: unset; margin-left: 15px;"
                                        >
                                        <i class="fas fa-info-circle"></i>
                                    </button>

                                    <ng-template #popContentObjetivo>
                                        Completar con nombre de la Encargada de Convivencia o de la Directora/Encargada de la Unidad Educativa.
                                    </ng-template>
                                </td>
                            </tr>
                        </table>
                    </div>

                </div>
            </div>
            <br>
        </div>
    </div>
</div>


<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Informe Plan de Gestión de Convivencia</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>



<ngx-spinner></ngx-spinner>